<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-md-6 mb-3 mb-md-0">
          <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </div>
        <div class="col-md text-md-right">
          <base-button class="rounded-pill" type="celcompink" @click.prevent="abrirAgregar(draftSingle)" v-show="permisos.create">
            Nueva Plantilla
            <i class="fas fa-plus-circle fa-lg text-pink"></i>
          </base-button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-header mb-4">
              <div class="d-flex justify-content-md-end">
                <base-input v-model="keySearch"
                            prepend-icon="fas fa-search"
                            placeholder="Buscar..."
                            class="mb-0">
                </base-input>
              </div>
            </div>

            <div class="col-12">
              <el-table
                class="table-responsive table-flush table-striped"
                header-row-class-name="thead-light"
                :data="queriedData"
              >
                <el-table-column label="Nombre" prop="name" min-width="200px" sortable>
                  <template v-slot="{row}">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <a href="#!" v-show="permisos.modify" @click.prevent="onEditDraft(row,true)" class="font-weight-600 mb-0 text-sm text-celcomblue">{{row.name}}</a>
                        <span v-show="!permisos.modify" class="font-weight-600 mb-0 text-sm text-celcomblue">{{row.name}}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Fecha Creación" prop="created" min-width="200px" sortable>
                  <template v-slot="{row}">{{ fechaFormato(row.created) }}</template>
                </el-table-column>

                <el-table-column label="Lista / Número" min-width="150px" sortable>
                  <template v-slot="{row}">{{ row.contactGroup.name }}</template>
                </el-table-column>

                <el-table-column label="Contactos" min-width="100px" sortable>
                  <template
                    v-slot="{row}"
                  >{{ (row.contactGroup.validos + row.contactGroup.invalidos)}}</template>
                </el-table-column>

                <el-table-column label="Acción" min-width="150px">
                  <div slot-scope="{row}" class="table-actions">
                    <el-tooltip content="Editar" placement="top">
                      <a
                        href="#!"
                        @click.prevent="onEditDraft(row)"
                        class="table-action table-action-edit"
                        data-toggle="tooltip"
                        data-original-title="Editar plantilla"
                        v-show="permisos.modify"
                      >
                        <i class="fas fa-edit"></i>
                      </a>
                    </el-tooltip>
                    <el-tooltip content="Eliminar" placement="top">
                      <a
                        href="#!"
                        @click.prevent="onDeleteDraft(row)"
                        class="table-action table-action-delete"
                        data-toggle="tooltip"
                        data-original-title="Eliminar plantilla"
                        v-show="permisos.destroy"
                      >
                        <i class="fas fa-trash"></i>
                      </a>
                    </el-tooltip>
                  </div>
                </el-table-column>
              </el-table>
            </div>

            <div
              slot="footer"
              class="col-12 mt-4 d-flex justify-content-around justify-content-md-between flex-wrap mb-4 align-items-center"
            >
                <div class="">
                  <small class="card-category">
                    Mostrando {{ from + 1 }} de {{ to }}  -  {{ total }} entradas

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                  </small>

                </div>

                <div class="d-flex align-items-center flex-sm-row flex-column mt-sm-3">

                  <el-select class="select-primary pagination-select mb-3 mb-sm-0 mr-3"
                              v-model="pagination.perPage"
                              placeholder="Per page" >
                    <el-option class="select-primary"
                                v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item" >
                    </el-option>
                  </el-select>
                  <base-pagination
                    class="pagination-no-border mb-0"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                  >
                  </base-pagination>

                </div>

            </div>
          </div>
        </div>
      </div>

      <div class="row">

        <modal
          :show.sync="modals.advertenciaSingle"
          gradient="danger"
          modal-classes="modal-danger modal-dialog-centered"
        >
          <h6 slot="header" class="modal-title" id="modal-title-notification">Borrar plantilla</h6>

          <div class="text-center">
            <i class="fas fa-exclamation-circle ni-3x mb-3"></i>
            <p class="mb-0">Estás a punto de eliminar esta plantilla.</p>
            <span>{{ draftSingle.name }}</span>
          </div>

          <template slot="footer">
            <base-button type="white text-danger" @click="borrarDraft(draftSingle)">Borrar</base-button>
            <base-button
              type="link"
              class="ml-auto text-white"
              @click="modals.advertenciaSingle = false"
            >Cerrar</base-button>
          </template>
        </modal>

        <modal
          :show.sync="modals.agregarBorrador"
          modal-classes="modal-secondary text-default"
          modal-content-classes="bg-gradient-secondary"
        >
          <h6 slot="header" class="modal-title text-default">Plantilla</h6>
          <form role="form">
            <base-input label="Nombre"
              v-model="draftSingle.name"
              class="mb-3"
              placeholder="Nombre"
              maxlength="40"
              prepend-icon="ni ni-world"
            ></base-input>

            <base-input class="mb-3" label="Seleccionar lista">
              <el-select
                v-model="draftSingle.contactGroup.contactGroupId"
                @change="getHeaderList"
                filterable
                placeholder="Seleccionar lista"
              >
                <el-option
                  v-for="option in selectOptionsListContact"
                  :key="option.contactGroupId"
                  :label="option.name"
                  :value="option.contactGroupId"
                ></el-option>
              </el-select>
            </base-input>


          <base-input>

            <el-select v-model="validForm.selectLanding"
                        filterable
                        placeholder="Seleccionar SMS Link"
                        >
              <el-option v-for="option in selectOptionsListLanding"
                          :key="option.ladingId"
                          :label="option.name"
                          :value="option.link"
                          >
              </el-option>
            </el-select>
          </base-input>

            <base-input class="mb-0" prepend-icon="ni ni-email-83" label="Redactar mensaje">
              <textarea v-model="draftSingle.message" class="form-control" rows="5" placeholder="Mensaje"></textarea>
            </base-input>

            <div>
              <base-button class="mt-2"
                size="sm"
                type="celcomblue"
                @click="putFieldMessage(header)"
                v-for="header in validForm.headersContactList"
                :key="header"
                >{{header.toUpperCase()}}</base-button>
            </div>



            <div class="custom-control custom-checkbox">
              <input id="cbId"
                      class="custom-control-input"
                      type="checkbox"
                      v-model="draftSingle.master"/>
              <label for="cbId" class="custom-control-label mb-3">
                <slot>
                  <span>
                    Master
                  </span>
                </slot>
              </label>
            </div>

            <label class="mt-4 form-control-label">
              Agregar adjunto
              <el-tooltip content="Esto generará una URL dinámica para tu mensaje" placement="right">
                <i class="btn-tooltip fas fa-question-circle text-gray"></i>
              </el-tooltip>
            </label>

            <dropzone-file-upload v-model="fileSingle" @drop="handleDrop"></dropzone-file-upload>

            <div class="d-flex justify-content-between my-4" v-if="!modals.formSingle">
              <base-button type="celcompink" @click="guardarNuevo(draftSingle)">Guardar</base-button>
              <base-button outline type="celcompink" @click="modals.agregarBorrador = false">Cerrar</base-button>
            </div>
            <div class="d-flex justify-content-between my-4" v-else>
              <base-button type="celcompink" @click="guardarEdicion(draftSingle)">Guardar</base-button>
              <base-button outline type="celcompink" @click="modals.agregarBorrador = false">Cerrar</base-button>
            </div>
          </form>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option
} from "element-ui";
import { BasePagination, Modal, Dialog } from "@/components";
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import FileInput from "@/components/Inputs/FileInput";
import moment from "moment";
import XLSX from "xlsx";
import clientPaginationMixin from "@/views/Tables/PaginatedTables/clientPaginationMixin";

 import swal from 'sweetalert2';
import AES256 from "aes-everywhere";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Config from "@/config/config.js";
import { getUser, setUser, encryptAES, horaAhora, search_data, onPermissionsUser,getUserSub } from "@/util/util.js";

Vue.use(VueAxios, axios);
Vue.use(Dialog);

export default {
  mixins: [clientPaginationMixin],
  components: {
    DropzoneFileUpload,
    BasePagination,
    FileInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
    Dialog
  },
  data() {
    return {
      inputs: {
        file: []
      },
      keySearch:"",
      currentPage: 1,
      tableData: [],
      listaContactos: [],
      selectedRows: [],
      tabContact: false,
      listaNombre: "",
      contactGroup: {},
      contactSingle: {},
      draftSingle: {
        name:"",
        message: "",
        master:false,
        shortUrlValue:"",
        shortUrl:false,
        cloudinaryId:"",
        contactGroup:{
          contactGroupId:""
        }
      },
      modals: {
        formSingle: false,
        formGroup: false,
        advertenciaSingle: false,
        advertenciaGroup: false,
        agregarBorrador: false,
        agregarMasivo: false
      },
      fileSingle: [],
      selectOptionsListContact: [],
      selectOptionsListLanding: [],
      validForm: {
        estado: false,
        field: "",
        campaingName: "",
        CodePhoneContact: getUser().customer.country.phoneCode,
        PhoneContact: "",
        listContact: "",
        dateProgramgContact: "",
        menssageContact: "",
        selectDraft: "",
        selectLanding:[],
        StepPreview: false,
        dateSend: "",
        sendingsms: "",
        contacts: [],
        headersContactList: [],
        fileUrl: []
      },
      permisos: {
        create: onPermissionsUser('drafts.xhtml', 'create'),
        modify: onPermissionsUser('drafts.xhtml', 'modify'),
        destroy: onPermissionsUser('drafts.xhtml', 'destroy'),
      }
    };
  },
  methods: {
    /**
     * IMPORTAR ARCHIVO URL
     */
    handleDrop(e) {


    },

    putFieldMessage(header) {
      this.draftSingle.message += "{#" + header.toUpperCase() + "}";
    },
    getHeaderList() {
      var self = this;
      var contactGroup;
      this.selectOptionsListContact.forEach(function(key) {
        if (key.contactGroupId == self.validForm.listContact ||
        key.contactGroupId == self.draftSingle.contactGroup.contactGroupId) {
          contactGroup = key;
        }
      });
      var array = contactGroup.header.split("|");
      var filtered = array.filter(function(el) {
        return el != "";
      });

      this.validForm.headersContactList = filtered;
      this.validForm.headersContactList.push("PHONE")
    },
    obtenerLista() {

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      //self.$loading.show();

      let js = {
        time_expired: horaAhora(),
        customer: encodeURIComponent(JSON.stringify(user.customer))
      };

      var body = new URLSearchParams();
      body.append("TOKEN", encryptAES(js));

      Vue.axios
        .post(Config.url_service + Config.draft_available, body, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(response) {
          console.log(response);

          if (response.data.response === "200") {
            console.log(response.data.data);

            self.tableData = response.data.data;
          } else {
            console.log("No se encontró lista");
            swal({
              title: "No se encontró lista",
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'warning',
            })

          }
         // self.$loading.hide();

        })
        .catch(function(error) {
          console.log("No se encontró lista", error);
          swal({
              title: "No se encontró lista",
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'warning',
          })

         // self.$loading.hide();

        });
    },
    onEditDraft(row) {
      let self = this;
      let modals = modals;

      self.draftSingle = row;
      self.modals.agregarBorrador = true;
      self.modals.formSingle = true;

      self.getHeaderList();
      if(self.draftSingle.shortUrlValue!=""){

        self.validForm.headersContactList.push("LINK");

      }
    },


      /**
       * CARGAR LISTA DE LANDING
       */
      loadLanding(){

      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer_user":encodeURIComponent(JSON.stringify(user))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.landing_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {

              self.selectOptionsListLanding = response.data.data;

            } else {
              console.log("No se encontró lista de landing");
            }


        })
        .catch(function (error) {
            console.log("No se encontró lista landing ",error);
        });

      },


    guardarEdicion(draftSingle) {

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      this.$loading.show();



       if(this.draftSingle.name=="" || this.draftSingle.message=="" || this.draftSingle.contactGroup.length<=0){

            swal({
                title: "Error debe completar los datos requeridos",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
              this.$loading.hide();

              return false;
      }

      let js = {
        time_expired: horaAhora(),
        customer: encodeURIComponent(JSON.stringify(user.customer)),
        draft: encodeURIComponent(JSON.stringify(this.draftSingle))
      };

      var body = new URLSearchParams();
      body.append("TOKEN", encryptAES(js));

      Vue.axios
        .post(Config.url_service + Config.draft_edit, body, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(response) {
          console.log(response);

          if (response.data.response === "200") {

            console.log(response.data.data);

            self.obtenerLista();
            self.modals.agregarBorrador = false;

            swal({
                  title: "Datos guardados",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill'
                })

          } else {
            console.log("No se pudo editar plantilla");

            swal({
                title: "Error no se pudo editar plantilla",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
          }

          self.$loading.hide();
        })
        .catch(function(error) {
          console.log("No se pudo editar plantilla", error);

            swal({
                title: "Error no se pudo editar plantilla",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })

            self.$loading.hide();
        });
    },
    onDeleteDraft(row) {
      let self = this;
      let modals = modals;

      self.draftSingle = row;
      self.modals.advertenciaSingle = true;
    },
    borrarDraft(draftSingle) {
      this.$loading.show();

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        time_expired: horaAhora(),
        customer: encodeURIComponent(JSON.stringify(user.customer)),
        draft: encodeURIComponent(JSON.stringify(draftSingle))
      };

      var body = new URLSearchParams();
      body.append("TOKEN", encryptAES(js));

      Vue.axios
        .post(Config.url_service + Config.draft_delete, body, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(response) {
          console.log(response);

          if (response.data.response === "200") {
            console.log(response.data.data);

            self.obtenerLista();
            self.modals.advertenciaSingle = false;

            swal({
                  title: "Datos borrados",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill'
                })

          } else {
            console.log("No se pudo borrar plantilla");

            swal({
                title: "Error no se pudo borrar plantilla",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })

          }
        })
        .catch(function(error) {
          console.log("No se pudo borrar plantilla", error);

          swal({
                title: "Error no se pudo borrar plantilla",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
        });

      self.$loading.hide();
    },
    abrirAgregar(draftSingle) {
      let self = this;
      let modals = modals;

      self.draftSingle= {
        name:"",
        message: "",
        shortUrlValue:"",
        shortUrl:false,
        cloudinaryId:"",
        contactGroup:{
          contactGroupId:""
        }
      }

      self.modals.formSingle = false;
      self.modals.agregarBorrador = true;
    },
    guardarNuevo(draftSingle) {
      this.$loading.show();

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();


      if(this.draftSingle.name=="" || this.draftSingle.message=="" || this.draftSingle.contactGroup.length<=0){

            swal({
                title: "Error debe completar los datos requeridos",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
              this.$loading.hide();

              return false;
      }


      var contactGroup;
      this.selectOptionsListContact.forEach(function(key) {
        if (key.contactGroupId == self.validForm.listContact ||
        key.contactGroupId == self.draftSingle.contactGroup.contactGroupId) {
          contactGroup = key;
        }
      });

      let nuevoDraft = {
        name: this.draftSingle.name,
        message: this.draftSingle.message,
        master: this.draftSingle.master,
        shortUrlValue:this.draftSingle.shortUrlValue,
        shortUrl:this.draftSingle.shortUrl,
        cloudinaryId:this.draftSingle.cloudinaryId,
        contactGroup: contactGroup
      };

      console.log(nuevoDraft);

      let js = {
        time_expired: horaAhora(),
        customer: encodeURIComponent(JSON.stringify(user.customer)),
        draft: encodeURIComponent(JSON.stringify(nuevoDraft))
      };

      var body = new URLSearchParams();
      body.append("TOKEN", encryptAES(js));

      Vue.axios
        .post(Config.url_service + Config.draft_add, body, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(response) {
          console.log(response);

          if (response.data.response === "200") {
            console.log(response.data.data);

            self.draftSingle= {
              name:"",
              message: "",
              shortUrlValue:"",
              shortUrl:false,
              cloudinaryId:"",
              contactGroup:{
                contactGroupId:""
              }
            }

            self.obtenerLista();
            self.modals.agregarBorrador = false;

            swal({
                  title: "Datos guardados",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill'
                })

          } else {
            console.log("No se pudo crear plantilla");

            swal({
                title: "Error no se pudo crear plantilla",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
          }

          self.$loading.hide();
        })
        .catch(function(error) {
          console.log("No se pudo crear plantilla", error);

          swal({
                title: "Error no se pudo crear plantilla",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
        });
    },
    fechaFormato(unixTimestamp) {
      return moment(unixTimestamp).format("YYYY-MM-DD HH:mm:ss");
    },
    loadGroupContact() {
      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        time_expired: horaAhora(),
        customer: encodeURIComponent(JSON.stringify(user.customer))
      };

      var body = new URLSearchParams();
      body.append("TOKEN", encryptAES(js));

      Vue.axios
        .post(Config.url_service + Config.contact_available, body, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(response) {
          console.log(response);

          if (response.data.response === "200") {
            self.selectOptionsListContact = response.data.data;
          } else {
            console.log("No se encontró lista de contacto");
            swal({
                title: "Error no se encontró lista de contacto",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })

          }
        })
        .catch(function(error) {
          console.log("No se encontró lista", error);
          swal({
                title: "Error no se encontró lista de contacto",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
        });
    }
  },
  mounted() {
    this.obtenerLista();
    this.loadGroupContact();
    this.loadLanding();

    if(!onPermissionsUser('drafts.xhtml', 'view')) {
        swal({
          title: 'No tienes los permisos para acceder a esta página.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          type: 'error',
          }).then(function() {
            window.location.href="/dashboard";
        })

      }
  },
  watch: {



    'validForm.selectLanding'(newVal){
      let self = this;
      self.draftSingle.message+=" "+newVal;
    },

      'keySearch'(newVal){
          if(newVal.toString().length>3){
            this.searchedData = search_data(newVal, this.tableData);
          }else{
            this.searchedData = this.tableData;
          }
      },


      /**
     * IMPORTAR LISTA DESDE EXCEL
     */
     'fileSingle'(e){

          var self = this;

      var files = e,
        f = files[0];

      let formData = new FormData();
      formData.append("file", f);

      this.$loading.show();

      Vue.axios
        .post(Config.url_service + Config.upload_file_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {

            console.log("upload sucsess", res);

          if (res.status === 200 && res.data.includes("http")) {


            self.getHeaderList();
            self.validForm.headersContactList.push("LINK");

            let result = res.data.split("|");
            self.draftSingle.shortUrlValue = (result[0]!=null) ? result[0] : "";
            self.draftSingle.shortUrl = true;
            self.draftSingle.cloudinaryId = (result[1]!=null) ? result[1] : "";

             swal({
                  title: "Archivo Cargado",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill'
                })

          } else {
            swal({
                title: "Error no se pudo cargar archivo",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
          }

          this.$loading.hide();


        })
        .catch(error => {
          console.log("No se pudo cargar", error);
          this.$loading.hide();

             swal({
                title: "Error no se pudo cargar archivo",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
        });

     },

  },
  create() {
    this.$loading.show();
  },
  computed: {}
};
</script>

<style>
.busy-mask {
  z-index: 1051;
}
</style>
